import React from 'react'
import DashNavbar from './navbar/Navbar'
import DashMenu from './menu/DashMenu'
import DashFooter from './footer/DashFooter'
import { Outlet } from 'react-router-dom'
import '../../../css/global.scss'

const Dashboard = () => {
  return (
    <div className='bg-[#2a3447] text-teal-50 ltr'>
      <DashNavbar />
      <div className='flex'>
        <div className='w-[250px] p-5 border-r-4 '>
          <DashMenu />
        </div>
        <div className='p-4 w-[100%]'>
          <Outlet />
        </div>
      </div>
      <DashFooter />
    </div>
  );
};

export default Dashboard;

